let base = window._env_.VUE_APP_ADMIN_HOST

export const submitBatchWithdraw = params => {
  return axios.post(`${base}/batch_withdraw/upload`, params)
}

export const batchWithdrawList = params => {
  return axios.post(`${base}/excel/query_upload`, params)
}

export const downBatchSourceFile = params => {
  return axios.get(`${base}/batch_withdraw/batch_download_` + params.id, {params})
}
export const batchWithdrawBatchList = params => {
  return axios.get(`${base}/batch_withdraw/batch_list`, {params})
}
export const batchWithdrawBatchDetail = id => {
  return axios.get(`${base}/batch_withdraw/batch_detail_` + id)
}
export const batchWithdrawBatchDetailByUser = params => {
  return axios.get(`${base}/batch_withdraw/batch_detail_` + params.id, {params})
}
export const batchWithdrawBatchConfirm = params => {
  return axios.post(`${base}/batch_withdraw/batch_confirm_` + params.id, params)
}
export const batchWithdrawBatchRollback = params => {
  return axios.post(`${base}/batch_withdraw/batch_rollback_` + params.id, params)
}
export const batchRollbackTable = params => {
  return axios.get(`${base}/batch_withdraw/batch_rollback_upload_list`, {params})
}
export const uploadBatchRollback = params => {
  return axios.post(`${base}/batch_withdraw/batch_rollback_upload_` + params.id, params.data)
}
export const batchWithdrawBatchSummary = id => {
  return axios.get(`${base}/batch_withdraw/batch_summary_` + id)
}

export const getWithdrawList = params => {
  return axios.post(`${base}/batch_withdraw/withdraw_list`, params)
}
export const withdrawGenExcel = params => {
  return axios.post(`${base}/batch_withdraw/withdraw_gen_excel`, params)
}
export const cancelWithdraw = params => {
  return axios.post(`${base}/batch_withdraw/cancel_withdraw_` + params.id, params)
}
// 批量驳回
export const batchCancelWithdraw = params => {
  return axios.post(`${base}/batch_withdraw/batch_cancel_withdraw`, params)
}
export const withdrawDetail = params => {
  return axios.post(`${base}/batch_withdraw/withdraw_detail_` + params.id, params)
}
export const withdrawWx = params => {
  return axios.post(`${base}/batch_withdraw/batch_withdraw_wx_` + params.id, params)
}
export const inactiveUserList = params => {
  return axios.post(`${base}/query_inactive_user`, params)
}



// WEBPACK FOOTER //
// ./src/views/finance/finance.api.js